import { render, staticRenderFns } from "./OrganizerEditDialog.vue?vue&type=template&id=3022d93a&scoped=true"
import script from "./OrganizerEditDialog.vue?vue&type=script&lang=js"
export * from "./OrganizerEditDialog.vue?vue&type=script&lang=js"
import style0 from "./OrganizerEditDialog.vue?vue&type=style&index=0&id=3022d93a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3022d93a",
  null
  
)

export default component.exports